"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const BehaviorSubject_1 = require("rxjs/BehaviorSubject");
const superstore_promiser_1 = require("./io/superstore-promiser");
const dymoloader_1 = require("./io/dymoloader");
const uicontrol_1 = require("./controls/uicontrol");
const sensorcontrol_1 = require("./controls/sensorcontrol");
const jsongraph_1 = require("./io/jsongraph");
/**
 * A class for easy access of all dymo core functionality.
 */
class DymoManager {
    constructor(dymoStore, fetcher) {
        this.dymoUris = [];
        this.uiControls = [];
        this.sensorControls = [];
        this.graphs = [];
        this.attributeInfo = new BehaviorSubject_1.BehaviorSubject([]);
        this.store = dymoStore ? dymoStore : new superstore_promiser_1.SuperStorePromiser(fetcher);
        this.loader = new dymoloader_1.DymoLoader(this.store, fetcher);
    }
    init(ontologiesPath) {
        return new Promise(resolve => {
            this.store.loadOntologies(ontologiesPath)
                .then(() => resolve());
        });
    }
    getJsonGraph(nodeClass, edgeProperty, cacheNodes) {
        let newGraph = new jsongraph_1.JsonGraphSubject(nodeClass, edgeProperty, this.store, cacheNodes);
        this.graphs.push(newGraph);
        return newGraph.asObservable();
    }
    getAttributeInfo() {
        return this.attributeInfo.asObservable();
    }
    loadIntoStore(...fileUris) {
        return this.loader.loadIntoStore(...fileUris)
            .then(() => this.loadFromStore());
    }
    loadIntoStoreFromString(rdf) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.processLoadedStuff(yield this.loader.loadFromString(rdf));
        });
    }
    loadDymoFromJson(fileUri) {
        return this.loader.loadFromFiles(fileUri)
            .then(loadedStuff => this.processLoadedStuff(loadedStuff));
    }
    loadFromStore(...uris) {
        return __awaiter(this, void 0, void 0, function* () {
            let loadedStuff = yield this.loader.loadFromStore(...uris);
            return this.processLoadedStuff(loadedStuff);
        });
    }
    processLoadedStuff(loadedStuff) {
        return __awaiter(this, void 0, void 0, function* () {
            this.dymoUris = this.dymoUris.concat(loadedStuff.dymoUris);
            this.rendering = loadedStuff.rendering;
            this.uiControls = (_.values(loadedStuff.controls)).filter(c => c instanceof uicontrol_1.UIControl);
            this.sensorControls = _.values(loadedStuff.controls).filter(c => c instanceof sensorcontrol_1.SensorControl);
            this.graphs.forEach(g => g.update());
            this.store.getAttributeInfo().then(info => this.attributeInfo.next(info));
            return loadedStuff;
        });
    }
    //TODO REMOVE THIS FUNCTION SOMETIME!
    getStore() {
        return this.store;
    }
    getLoadedDymoUris() {
        return this.dymoUris;
    }
    getTopDymo() {
        return this.dymoUris[0];
    }
    getRendering() {
        return this.rendering;
    }
    getUIControls() {
        return this.uiControls;
    }
    getSensorControls() {
        return this.sensorControls;
    }
}
exports.DymoManager = DymoManager;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/manager.js
// module id = 643
// module chunks = 3